import { getFrontendVersion } from '@repo/api';
import { queryKeys, useAppType } from '@repo/lib';
import type { AppType } from '@repo/types';
import { useQuery } from '@tanstack/react-query';

export const useVersionQuery = (appType?: AppType) => {
  const defaultAppType = useAppType();
  const resolvedAppType = appType ?? defaultAppType;

  const { data } = useQuery({
    queryFn: () => getFrontendVersion(resolvedAppType),
    queryKey: queryKeys.version.frontend(resolvedAppType),
    refetchInterval: 1000 * 60 * 5,
  });

  return data?.appVersion ?? '';
};
